import { parse } from "date-fns";
import { useEffect, useState, useMemo } from "react";

const useCurrentTime = () => {
  const userLocale = navigator.language;

  const langFormat: any = useMemo(
    () => ({
      de: "de-DE",
      en: "en-EN",
    }),
    []
  );

  const dateFormats: any = {
    de: "d.M.yyyy",
    en: "M/d/yyyy",
  };

  const [currentTime, setCurrentTime] = useState<string>(
    new Date().toLocaleString(langFormat[userLocale] || "de-DE")
  );
  const [currentDate, setCurrentDate] = useState<any>(
    new Date().toLocaleDateString(langFormat[userLocale] || "de-DE")
  );

  // Update current date and time every 10 milliseconds
  useEffect(() => {
    const timerId = setInterval(() => {
      const now = new Date();

      const date = now.toLocaleDateString(langFormat[userLocale] || "de-DE");
      const time = now.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });

      setCurrentDate(date);
      setCurrentTime(time);
    }, 10);
    return () => clearInterval(timerId);
  }, [langFormat, userLocale]);

  const dateFormat: any = dateFormats[userLocale] || "d.M.yyyy";

  const parsedDate = parse(currentDate, dateFormat, new Date());

  return { currentDate: parsedDate, currentTime };
};

export default useCurrentTime;
